import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import config from "./config/config";
import { MoralisProvider } from "react-moralis";
import { SidebarProvider } from "../src/component/Context/SidebarContext";
import { GamePopupProvider } from "../src/component/Context/GamePopupContext";
import { AuthContextProvider } from "./AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MoralisProvider
      serverUrl={`${config.moralisURL}`}
      appId={`${config.moralisAPIKey}`}
    >
      <AuthContextProvider>
        <SidebarProvider>
          <GamePopupProvider>
            <App />
          </GamePopupProvider>
        </SidebarProvider>
      </AuthContextProvider>
    </MoralisProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
